module.exports = __webpack_public_path__ + "img/龙宫.1d0ec290.png";